import { useMutation } from '@tanstack/react-query';
import { PromptVariable } from '../../types';
import useAuth from '../../../auth/authContext';
import useApi from '../../../api/backendApiContext';
import { useQueryCacheManager } from '../../../hooks/useQueryCacheManager';
import { useNotification } from '../../../notification/notificationsContext';

export const useUpdateVariableMutation = () => {
  const {
    state: { user },
  } = useAuth();
  const { growegyAIApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const { notifySuccess, notifyError } = useNotification();

  return useMutation(
    async (variable: PromptVariable) => {
      if (!user || !variable.id) return null;
      return growegyAIApi.updateVariable(user.userId, variable);
    },
    {
      onMutate: (promptVariable) => {
        if (!promptVariable) return;
        queryCacheManager.updatePromptVariable(promptVariable);
        notifySuccess({
          logMsg: `Variable ${promptVariable.variableValue.name} saved`,
          notificationMsg: 'Personalization changes saved',
        });
      },
      onError: async (error) => {
        await queryCacheManager.invalidateVariables();
        notifyError({
          err: error,
          logMsg: `Failed to update variable`,
          notificationMsg: 'Update failed',
        });
      },
    }
  );
};
